// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6216":"css/app.6964","8318":"css/admin-app.6964"}[chunkId] + ".css";
};